module.exports = __webpack_public_path__ + "fontawesome-webfont.af7ae505a9eed503f8b8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/awesome-icons/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = 1373
// module chunks = 24